import { APPS } from '@flow/case-manager'

import inboxEn from './inboxEn.json'
import documentNamesEn from './documentNamesEn.json'
import processEn from './processEn.json'
import businessStatusesEn from './businessStatusesEn.json'
import searchEn from './searchEn.json'

export const customTranslations = [
  {
    app: APPS.Inbox,
    language: 'en',
    translates: {
      ...inboxEn,
      ...documentNamesEn,
      ...businessStatusesEn
    }
  },
  {
    app: APPS.Search,
    language: 'en',
    translates: {
      ...inboxEn,
      ...documentNamesEn,
      ...businessStatusesEn,
      ...searchEn
    }
  },
  {
    app: APPS.Process,
    language: 'en',
    translates: processEn
  }
]

export default {
  customTranslations
}
